"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconDownloadBox = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M25.71 26.5a1.54 1.54 0 0 0 0 2.19l8.2 8.2a1.56 1.56 0 0 0 1.09.46 1.51 1.51 0 0 0 1.09-.46l8.2-8.2a1.55 1.55 0 1 0-2.19-2.19l-5.55 5.55V5.51a1.55 1.55 0 1 0-3.09 0v26.54L27.9 26.5a1.54 1.54 0 0 0-2.19 0zm0 0"
  }), _react["default"].createElement("path", {
    d: "M60.27 39.17L54.89 19.7a1.57 1.57 0 0 0-.85-1l-.15-.07a1.58 1.58 0 0 0-.64-.14h-9.7a1.55 1.55 0 0 0 0 3.09h8.66l4.55 16.47h-12a1.54 1.54 0 0 0-1.55 1.55V41a3.71 3.71 0 0 1-3.71 3.71H30A3.71 3.71 0 0 1 26.33 41v-1.4a1.54 1.54 0 0 0-1.55-1.55H13.23l4.57-16.5h8.66a1.55 1.55 0 0 0 0-3.09h-9.71a1.58 1.58 0 0 0-.64.14l-.15.07a1.53 1.53 0 0 0-.85 1L9.73 39.13a1.72 1.72 0 0 0-.06.41v8.12a11.17 11.17 0 0 0 11.15 11.16h28.36a11.17 11.17 0 0 0 11.15-11.16v-8.08a1.2 1.2 0 0 0-.06-.41zm-3 8.5a8.07 8.07 0 0 1-8.06 8.06H20.82a8.07 8.07 0 0 1-8.06-8.06v-6.52h10.5a6.81 6.81 0 0 0 6.8 6.64h9.44a6.81 6.81 0 0 0 6.8-6.64h11v6.52zm0 0"
  })),
  height: undefined,
  width: undefined
});
IconDownloadBox.displayName = 'IconDownloadBox';
var _default = IconDownloadBox;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/download-box.js
// module id = 127
// module chunks = 0